import * as React from 'react'
import ActionButton from 'uiComponents/buttons'
import { useTranslation } from 'translations'
import './css/addTaxConfigurationElement.scss'

interface AddTaxConfigurationElementProps {
    fullWidth: boolean
    onClick: () => void
}

export const AddTaxConfigurationElement = (props: AddTaxConfigurationElementProps) => {
    const { t } = useTranslation()
    const { fullWidth, onClick } = props

    return (
        <>
            <div className={`addTaxConfigurationElement ${fullWidth ? 'full' : 'half'}`}>
                <div className="title">{t('settings.accountSettings.taxConfigurations.add.title')}</div>
                <div className="subtitle">{t('settings.accountSettings.taxConfigurations.add.description')}</div>
                <ActionButton onClick={onClick}>
                    {t('settings.accountSettings.taxConfigurations.add.createButton')}
                </ActionButton>
            </div>
        </>
    )
}
